import { Skeleton } from "@/v2/components/ui/skeleton";

/** Mirrors EditProgramPanel's loaded layout (thumb + title, trim fields,
 *  description, action row) so the panel doesn't pop from an empty state
 *  into full content once the first program auto-selects. */
export function EditProgramPanelSkeleton() {
  return (
    <section
      className="rounded-lg border border-border bg-card"
      style={{ padding: 20 }}
      aria-hidden
      data-testid="edit-program-skeleton"
    >
      <div className="flex items-center justify-between" style={{ gap: 12 }}>
        <h2 className="font-bold text-foreground" style={{ fontSize: 20, lineHeight: 1.3 }}>
          Edit Program
        </h2>
        <Skeleton className="v2-skeleton-wave h-9 w-24 rounded-md" />
      </div>

      <div className="flex items-center" style={{ gap: 16, marginTop: 16 }}>
        <Skeleton
          className="v2-skeleton-wave shrink-0 rounded-md"
          style={{ width: 128, aspectRatio: "16 / 9" }}
        />
        <div className="flex-1">
          <Skeleton className="v2-skeleton-wave h-4 w-4/5 rounded" />
          <Skeleton className="v2-skeleton-wave h-3 w-3/5 rounded" style={{ marginTop: 8 }} />
        </div>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
          gap: 16,
          marginTop: 20,
        }}
      >
        <div>
          <Skeleton className="v2-skeleton-wave h-3 w-20 rounded" style={{ marginBottom: 8 }} />
          <Skeleton className="v2-skeleton-wave h-9 w-full rounded-md" />
        </div>
        <div>
          <Skeleton className="v2-skeleton-wave h-3 w-20 rounded" style={{ marginBottom: 8 }} />
          <Skeleton className="v2-skeleton-wave h-9 w-full rounded-md" />
        </div>
      </div>

      <div style={{ marginTop: 20 }}>
        <Skeleton className="v2-skeleton-wave h-3 w-24 rounded" style={{ marginBottom: 8 }} />
        <Skeleton className="v2-skeleton-wave h-20 w-full rounded-md" />
      </div>

      <Skeleton className="v2-skeleton-wave h-4 w-48 rounded" style={{ marginTop: 20 }} />

      <div className="flex items-center" style={{ gap: 12, marginTop: 20 }}>
        <Skeleton className="v2-skeleton-wave h-9 flex-1 rounded-md" />
        <Skeleton className="v2-skeleton-wave h-9 flex-1 rounded-md" />
      </div>
    </section>
  );
}
